var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.linear)?_c('v-progress-linear',{attrs:{"rounded":"","color":_vm.color,"value":_vm.value,"indeterminate":_vm.indeterminate}}):_c('v-progress-circular',{attrs:{"color":_vm.color,"size":_vm.radius,"value":_vm.value,"indeterminate":_vm.indeterminate}})
}
var staticRenderFns = []

export { render, staticRenderFns }